import { CodeSection } from 'civil-status/constants/code-subject-section';
import { Consenso, SectionVM } from 'civil-status/view-models/step-form';

export const transformerConsenso = (
  dataSection?: SectionVM,
  dataEventoRiconoscimento?: SectionVM,
  dataAttoConsensoAcoP?: SectionVM,
  dataMarriage?: SectionVM
): Consenso | undefined => {
  if (!(dataSection || dataEventoRiconoscimento || dataAttoConsensoAcoP || dataMarriage)) {
    return undefined;
  }

  return {
    key:
      dataSection?.idConsenso ||
      dataEventoRiconoscimento?.idConsenso ||
      dataAttoConsensoAcoP?.idConsenso ||
      dataMarriage?.idConsenso
        ? {
            idConsenso:
              dataSection?.idConsenso ||
              dataEventoRiconoscimento?.idConsenso ||
              dataAttoConsensoAcoP?.idConsenso ||
              dataMarriage?.idConsenso,
          }
        : undefined,
    mancatoConsenso: dataSection?.reasonLackConsent || undefined,
    datiProdotti: dataAttoConsensoAcoP?.actForm?.presentationDocument
      ? dataAttoConsensoAcoP?.actForm?.presentationDocument
      : dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_ASS_RICO ||
        dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_RICO_SENT
      ? undefined
      : dataEventoRiconoscimento?.presentationDocument || undefined,
    tipoConsenso:
      dataEventoRiconoscimento?.typologyConsent || dataMarriage?.typologyConsent || undefined,
    tipoSezione:
      dataMarriage?.typePersistence ||
      dataSection?.typePersistence ||
      dataEventoRiconoscimento?.typePersistence ||
      undefined,
    codiceSezione: dataSection?.codeSection || dataEventoRiconoscimento?.codeSection || undefined,
  };
};
